(() => {
  const selector = '.product-card__image--secondary';
  const watched = new WeakSet();
  const markReady = async image => {
    image.removeAttribute('data-lm-hover-ready');
    if (!image.complete || !image.naturalWidth) return;
    const source = image.currentSrc;
    try { if (image.decode) await image.decode(); } catch {}
    if (image.isConnected && image.complete && image.naturalWidth && image.currentSrc === source) {
      image.setAttribute('data-lm-hover-ready', '');
    }
  };
  const nearby = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.loading = 'eager';
      markReady(entry.target);
      nearby.unobserve(entry.target);
    }
  }, {rootMargin: '500px'}) : null;
  const watch = image => {
    if (watched.has(image)) return;
    watched.add(image);
    image.addEventListener('load', () => markReady(image));
    image.addEventListener('error', () => image.removeAttribute('data-lm-hover-ready'));
    const media = image.closest('.product-card__media');
    const prepare = () => { image.loading = 'eager'; markReady(image); };
    media?.addEventListener('pointerenter', prepare, {once: true});
    media?.addEventListener('focus', prepare, {once: true});
    if (nearby) nearby.observe(image);
    else image.loading = 'eager';
    markReady(image);
  };
  const scan = root => {
    if (root.matches?.(selector)) watch(root);
    root.querySelectorAll?.(selector).forEach(watch);
  };
  scan(document);
  new MutationObserver(changes => {
    for (const change of changes) {
      if (change.type === 'attributes') {
        if (change.target.matches(selector)) markReady(change.target);
      } else {
        change.addedNodes.forEach(scan);
      }
    }
  }).observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset']});
})();


